import { gql, useQuery } from "@apollo/client"
import { CountryIntelligence, Maybe } from "@oysterhr/schema"

const ContractedResignationRulesQuery = gql`
  query ContractedResignationRulesQuery($countryCode: String!) {
    countryIntelligence(countryCode: $countryCode) {
      contractualResignationRules {
        notice {
          unit
          value
        }
        optionType
        oysterScore
      }
      contractualTerminationRules {
        notice {
          unit
          value
        }
        optionType
        oysterScore
      }
    }
  }
`

type UseTerminationAndResignationRulesProps = { countryCode?: Maybe<string> }
type UseTerminationAndResignationRulesParams = { countryCode: string }
type UseTerminationAndResignationRulesReturn = Pick<
  CountryIntelligence,
  "contractualResignationRules" | "contractualTerminationRules"
>

export const useTerminationAndResignationRules = ({
  countryCode,
}: UseTerminationAndResignationRulesProps) => {
  const { data, loading, error } = useQuery<
    { countryIntelligence?: UseTerminationAndResignationRulesReturn },
    UseTerminationAndResignationRulesParams
  >(ContractedResignationRulesQuery, {
    variables: { countryCode: countryCode || "" },
    skip: !countryCode,
  })

  const resignationRules = data?.countryIntelligence?.contractualResignationRules
  const terminationRules = data?.countryIntelligence?.contractualTerminationRules

  return {
    resignationRules,
    terminationRules,
    loading,
    error,
  }
}
